import { createGetApi } from "@api/util/createGetApi";

import type { IApiResponse } from "@api";

import type { IPathBaseParam } from "./path";
import type { ICostumersStatsResponse } from "./types";

const getApis = createGetApi<
  IApiResponse<ICostumersStatsResponse>,
  IPathBaseParam,
  object
>("stores.customers.stats");

export const stats = {
  ...getApis,
};
